import queryString from 'query-string';

export function hasParam(search: string, param: string) {
  return param in queryString.parse(search);
}
